// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './theme/index.css'
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.config.productionTip = false

import store from './store/index';
import tools from './utils/public.js'

import "../static/font/index.css";
import "../static/font2/index.css";
import './style/element-variables.less'
import {
  getUser
} from "@/api/login";
// vue中导出excel表格模板
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
// 将excel表格模板设置全局
Vue.prototype.$FileSaver = FileSaver;
Vue.prototype.$XLSX = XLSX;
Vue.prototype.$tools = tools;
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts
// let token2 = localStorage.getItem('token')
router.beforeEach(async (to, from, next) => {
  let token = localStorage.getItem('tg_token')
  // console.log(to)
  // if (to.name == 'BoxRegister') {
  //   document.title = '玩家注册-冰火游戏'
  // }
  if (to.path == '/down/index' || to.path == '/discount') {
    next()
  } else if (!token) {
    if (to.path === '/login/index') {
      next()
    } else {
      next('/login/index')
    }
  } else {

    let user = store.getters.userInfo
    if (user.is_admin < 1 && to.path == '/home/back_recored') {
      next(from.fullPath)
    } else if (user.promote_level > 1 && to.path == '/index/oem') {
      next(from.fullPath)
    } else if (user.contract_sign_status == 0 && user.is_force_contract == 1 && to.path != '/') {
      next(from.fullPath)
    } else if (to.path === '/login/index') {
      next(from.fullPath)
    } else if (to.fullPath != '/' && !store.getters.userInfo.auth_real_name && store.getters.userInfo
      .is_force_name == 1) {
      next('/')
    } else {

      next()
    }
  }
})
// import {
//   autoRefresh
// } from "@/utils/auto-update"
// if (process.env.NODE_ENV === 'production') {
//   autoRefresh()
// }

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js